/*
 *
 * Surveys reducer
 *
 */

import { fromJS } from "immutable"
import {
  CREATE_SURVEY_WATCHER,
  CREATE_SURVEY_SUCCESS,
  CREATE_SURVEY_FAILED,
  GET_SURVEYS,
  GET_SURVEYS_SUCCESS,
  GET_SURVEYS_FAILED,
  GET_SURVEY_WATCHER,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_FAILED,
  GET_SURVEYS_TEMPLATE_WATCHER,
  GET_SURVEYS_TEMPLATE_SUCCESS,
  GET_SURVEYS_TEMPLATE_FAILED,
  DUPLICATE_SURVEY_WATCHER,
  DUPLICATE_SURVEY_SUCCESS,
  DUPLICATE_SURVEY_FAILED,
  GET_SURVEY_ENPS_WATCHER,
  GET_SURVEY_ENPS_SUCCESS,
  GET_SURVEY_ENPS_FAILED,
  GET_SURVEY_QUALITATIVE_WATCHER,
  GET_SURVEY_QUALITATIVE_SUCCESS,
  GET_SURVEY_QUALITATIVE_FAILED,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_FAILED,
  GET_SEGMENTS_WATCHER,
  GET_SURVEY_TYPES_WATCHER,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_FAILED,
  GET_SCOPE_TYPES_WATCHER,
  GET_SCOPE_TYPES_SUCCESS,
  GET_SCOPE_TYPES_FAILED,
  GET_SURVEYS_BY_INDICATORS_WATCHER,
  GET_SURVEYS_BY_INDICATORS_SUCCESS,
  GET_SURVEYS_BY_INDICATORS_FAILED,
} from "./constants"

export const initialState = fromJS({
  activeSurveys: [],
  leadershipSurveys: [],
  isLoadingSurveys: true,
  survey: [],
  isLoadingSurvey: true,
  surveysTemplate: [],
  isLoadingSurveysTemplate: true,
  surveyName: "",
  surveyEnps: [],
  isLoadingSurveyEnps: true,
  surveyQualitative: [],
  isLoadingSurveyQualitative: true,
  segments: [],
  isLoadingSegments: true,
  surveyTypes: [],
  isLoadingSurveyTypes: true,
  scopeTypes: [],
  isLoadingScopeTypes: true,
  surveysByIndicators: [],
})

function surveysReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SURVEYS_BY_INDICATORS_WATCHER:
      return state.set("isLoadingSurveys", true)
    case GET_SURVEYS_BY_INDICATORS_SUCCESS:
      return state
        .set("surveysByIndicators", action.payload)
        .set("isLoadingSurveys", false)
    case GET_SURVEYS_BY_INDICATORS_FAILED:
      return state.set("surveysByIndicators", []).set("isLoadingSurveys", false)
    case GET_SURVEY_ENPS_WATCHER:
      return (
        state
          // .set('surveyEnps', {})
          .set("isLoadingSurveyEnps", true)
      )
    case GET_SURVEY_ENPS_SUCCESS:
      return state
        .set("surveyEnps", action.payload)
        .set("isLoadingSurveyEnps", false)
    case GET_SURVEY_ENPS_FAILED:
      return state.set("surveyEnps", {}).set("isLoadingSurveyEnps", false)

    case GET_SURVEY_QUALITATIVE_WATCHER:
      return (
        state
          // .set('surveyQualitative', {})
          .set("isLoadingSurveyQualitative", true)
      )
    case GET_SURVEY_QUALITATIVE_SUCCESS:
      return state
        .set("surveyQualitative", action.payload)
        .set("isLoadingSurveyQualitative", false)
    case GET_SURVEY_QUALITATIVE_FAILED:
      return state
        .set("surveyQualitative", {})
        .set("isLoadingSurveyQualitative", false)

    case DUPLICATE_SURVEY_WATCHER:
      return state.set("isLoadingSurveys", true)
    case DUPLICATE_SURVEY_SUCCESS:
      return state.set("isLoadingSurveys", false)
    case DUPLICATE_SURVEY_FAILED:
      return state.set("isLoadingSurveys", undefined)

    case GET_SURVEYS_TEMPLATE_WATCHER:
      return state
        .set("surveysTemplate", [])
        .set("isLoadingSurveysTemplate", true)
    case GET_SURVEYS_TEMPLATE_SUCCESS:
      return state
        .set("surveysTemplate", action.payload)
        .set("isLoadingSurveysTemplate", false)
    case GET_SURVEYS_TEMPLATE_FAILED:
      return state
        .set("surveysTemplate", [])
        .set("isLoadingSurveysTemplate", false)

    case GET_SURVEY_WATCHER:
      return state
        .set("survey", [])
        .set("surveyName", "")
        .set("isLoadingSurvey", true)
    case GET_SURVEY_SUCCESS:
      return state
        .set("survey", action.payload.summary)
        .set("surveyName", action.payload.survey)
        .set("isLoadingSurvey", false)
    case GET_SURVEY_FAILED:
      return state.set("survey", []).set("isLoadingSurvey", false)

    case GET_SURVEYS:
      return state.set("isLoadingSurveys", true)
    case GET_SURVEYS_SUCCESS:
      return state
        .set("activeSurveys", action.payload.climate)
        .set("leadershipSurveys", action.payload.leadership)
        .set("isLoadingSurveys", false)
    case GET_SURVEYS_FAILED:
      return state
        .set("activeSurveys", [])
        .set("leadershipSurveys", [])
        .set("isLoadingSurveys", false)

    case CREATE_SURVEY_WATCHER:
      return state.set("isLoadingSurveys", true)
    case CREATE_SURVEY_SUCCESS:
      return state
        .set("isLoadingSurveys", false)
        .set("activeSurveys", action.payload)
    case CREATE_SURVEY_FAILED:
      return state.set("isLoadingSurveys", undefined)
    case GET_SEGMENTS_WATCHER:
      return state.set("segments", []).set("isLoadingSegments", true)
    case GET_SEGMENTS_SUCCESS:
      return state
        .set("segments", action.payload)
        .set("isLoadingSegments", false)
    case GET_SEGMENTS_FAILED:
      return state.set("segments", []).set("isLoadingSegments", false)
    case GET_SURVEY_TYPES_WATCHER:
      return state.set("surveyTypes", []).set("isLoadingSurveyTypes", true)
    case GET_SURVEY_TYPES_SUCCESS:
      return state
        .set("surveyTypes", action.payload)
        .set("isLoadingSurveyTypes", false)
    case GET_SURVEY_TYPES_FAILED:
      return state.set("surveyTypes", []).set("isLoadingSurveyTypes", false)
    case GET_SCOPE_TYPES_WATCHER:
      return state.set("scopeTypes", []).set("isLoadingScopeTypes", true)
    case GET_SCOPE_TYPES_SUCCESS:
      return state
        .set("scopeTypes", action.payload)
        .set("isLoadingScopeTypes", false)
    case GET_SCOPE_TYPES_FAILED:
      return state.set("scopeTypes", []).set("isLoadingScopeTypes", false)
    default:
      return state
  }
}

export default surveysReducer
